module.exports = __webpack_public_path__ + "img/zip-icon.428210b4.svg";